import React, { useEffect, useState } from "react";
import * as d3 from 'd3';

import TaxonLink from "web/ui/taxon_link";
import * as db from "web/db";
import { useTaxonomy } from "web/hooks";

// TODO: How should we import other classes css
// TODO: Figure out how to get `composes: ...` work
import classes from './species_table.module.css';
import data_table from './data_table.module.css';

export default function SpeciesTable(props: { query: () => Promise<db.SpeciesTable>, args: any }) {
  const [ table, setTable ] = useState<db.SpeciesTable|null>(null);
  const taxonomy = useTaxonomy();

  useEffect(() => {
    setTable(null); // TODO: Show an actual spinner during the load? Or some better transition
    props.query().then(t => { setTable(t) });
  }, [props.args]); // TODO: Figure out a better solution than the args hacks to force a rerender

  if (!table?.species.length) {
    return null;
  }

  const years = d3.range(table.years.min, table.years.max+1);

  return <table className={ `${classes.root} ${data_table.root}` }>
    <thead><tr>
      <th>#</th>
      <th>Species</th>
      { d3.range(table.years.min, table.years.max+1).map(y => {
        const total = d3.sum(table.species, s => s.years.includes(y) ? 1 : 0);
        const firsts = d3.sum(table.species, s => s.years[0] === y ? 1 : 0);

        return <YearHeader key={ y } year={y}>
          <i>{firsts}</i> / <i>{total}</i>
        </YearHeader>
      }) }
      <YearHeader year='All'><i>{table.species.length}</i></YearHeader>
    </tr></thead>
    <tbody>{
      table.species.map((row, i) => {
        const species = taxonomy.code(row.code);

        return <tr key={ row.code }>
          <td>{ i + 1 }</td>
          <td className={ classes.taxon_cell } ><TaxonLink taxon={ species }/></td>
          { years.map(y => {
            const idx = row.years.indexOf(y);
            return <td key={ y }>
              { idx === -1 && '' }
              { idx ===  0 && '✔' /* TODO: Bold instead of heavy-check? */ }
              { idx   >  0 && '✓' }
            </td>
          } )}
          <td>{ row.years.length }</td>
        </tr>;
      })
    }</tbody>
  </table>;
}

const YearHeader = ({ year, children }: { year: number|string, children: React.ReactNode }) => {
  return <th>
    <div className={ classes.year }>{ year }</div>
    <div className={ classes.year_count }>
      { children }
    </div>
  </th>;
}
